import axios from 'axios'
import { useAuthStore } from '@/stores/authStore'

const AUTH_PUBLIC = /\/auth\/(login|refresh|forgot|reset|verify|oidc|logout)/i
const PROPOSTA_PUBLIC = /\/propostas\/public\//i
const PROPOSTA_PUBLIC_ACTIONS =
  /\/propostas\/[^/]+\/(track|solicitar-revisao|aceitar)(?:\?|$|\/)/i
const PJ_CADASTRO_PUBLIC = /\/pj-agrada\/cadastro\//i
const PJ_LOOKUP_PUBLIC = /\/pj-agrada\/lookup\//i
const REFERRALS_PUBLIC = /\/referrals\/(register|cadastro\/confirmacao|auth\/(login|verify-otp|accept))(?:\?|$)/i

export function isPublicAuthRequest(url: string): boolean {
  return AUTH_PUBLIC.test(url)
}

export function isPublicPropostaRequest(url: string): boolean {
  return PROPOSTA_PUBLIC.test(url) || PROPOSTA_PUBLIC_ACTIONS.test(url)
}

export function isPublicPjCadastroRequest(url: string): boolean {
  return PJ_CADASTRO_PUBLIC.test(url) || PJ_LOOKUP_PUBLIC.test(url)
}

export function isPublicReferralRequest(url: string): boolean {
  return REFERRALS_PUBLIC.test(url)
}

export function isPublicApiRequest(url: string): boolean {
  return (
    isPublicAuthRequest(url) ||
    isPublicPropostaRequest(url) ||
    isPublicPjCadastroRequest(url) ||
    isPublicReferralRequest(url)
  )
}

/**
 * Aguarda bootstrap (refresh cookie / token em memória).
 * Rejeita se sessão resolvida como visitante ou timeout.
 */
export function waitForApiSession(timeoutMs = 20_000): Promise<string> {
  return new Promise((resolve, reject) => {
    let unsub: (() => void) | undefined
    let timer: ReturnType<typeof setTimeout> | undefined

    const cleanup = () => {
      unsub?.()
      if (timer) clearTimeout(timer)
    }

    const check = (): boolean => {
      const { authReady, token, isAuthenticated, sessionUsesCookie } = useAuthStore.getState()
      if (!authReady) return false

      if (token) {
        cleanup()
        resolve(token)
        return true
      }

      if (isAuthenticated && sessionUsesCookie) {
        cleanup()
        resolve('')
        return true
      }

      if (!isAuthenticated) {
        cleanup()
        reject(new axios.CanceledError('AUTH_GUEST'))
        return true
      }

      // Persist antigo: isAuthenticated sem token nem cookie de sessão confirmado
      cleanup()
      reject(new axios.CanceledError('AUTH_SESSION_INVALID'))
      return true
    }

    if (check()) return

    unsub = useAuthStore.subscribe(check)

    timer = setTimeout(() => {
      cleanup()
      reject(new axios.CanceledError('AUTH_SESSION_TIMEOUT'))
    }, timeoutMs)
  })
}
